var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSupportKey = function SvgSupportKey(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 5V11C21 19 15 21.6667 12 23C9 21.5 3 20 3 11V5L12 1L21 5ZM15.9609 6.3291C14.6539 5.72641 13.0199 5.94535 11.9307 7.04102C10.8958 8.0821 10.6231 9.562 11.1133 10.8223L6.15723 15.8086C5.9395 15.973 5.93965 16.3561 6.21191 16.5752L7.46387 17.8359C7.68163 18.055 8.00871 18.0548 8.22656 17.8359L13.1826 12.8496C14.4353 13.3428 15.9066 13.0684 16.9414 12.0273C18.0304 10.9315 18.3029 9.2876 17.6494 7.97266L15.2529 10.3291L13.6191 8.68457L15.9609 6.3291Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSupportKey);
export { ForwardRef as ReactComponent };